/*
* 包含n个接口请求函数模块
* */
import commonJS from '../common/js/commonJS'
import axios from './axios'
import envJS from '../common/js/env'
let Base64 = require('js-base64').Base64;
const BASE_URL = '/api'
var TOKEN_DATA = commonJS.getCookie('Authorization');

/**
 * 所有接口
 */
export const isHavePhone = params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/user/isHavePhone?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};

export const updatePhone = params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/user/updatePhone?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};

/**
 * 用户行为
 */
export const getUserInfo = params => {
  TOKEN_DATA = commonJS.getCookie('Authorization');
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/user/getUserId?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};

  //用户行为---登录接口
export const reqPwdLogin = params => {
    TOKEN_DATA = commonJS.getCookie('Authorization');
    params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/user/login?='+new Date().getTime(),'data='+params)
    .then(res => res.data);
};
//用户行为---请求短信
export const reqSendCode = params => {
  // type：0-注册 1-修改密码/忘记密码2-验证旧手机号3-绑定新手机号4-注册商家端
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/sms/send?='+new Date().getTime(),'data='+params)
    .then(res => res.data);
};
//用户行为---注册
export const reqRegister = params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/user/register?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//用户行为---修改密码
export const reqUpdatePwd = params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/user/pwd/update?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//用户行为---修改个人信息
export const reqUpdateInfo = params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  params=params.replace(/\+/g,'|')
  params=params.replace(/-/g,'_')
  return axios.post(BASE_URL+'/user/info/update?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费
//缴费单列表
export const reqUserNotpayList= params => {
  if(!params.userId){
	  return
  }
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/pay/userroom/notpay?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费---查询省市地区
export const reqArea = params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/roominfo/trend?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费---查询热力公司
export const reqCompany = params => {
	params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
	return axios.post(BASE_URL+'/roominfo/company?=' + new Date().getTime())
		.then(res => res.data);
};
//缴费---根据区查询小区
export const reqVillage = params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/roominfo/village?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费---根据区查询楼栋
export const reqBuilding= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/roominfo/villageBuilding?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费---根据区查询楼栋明细
export const reqBuildingDetail = params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/roominfo/villageBuildingDetail?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费---查询房屋信息
export const reqRoominfoList= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/roominfo/list?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费---查询房屋应缴记录
export const reqNotpayList= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/pay/room/notpay?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费---查询支付类型列表
export const reqPayType= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/pay/type?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费---查询支付方法列表
export const reqPayMethod= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/pay/method?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费---提交订单
export const reqPayOrderAdd= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/pay/order/add?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//浦发支付--提交订单
export const reqPFPayOrderAdd = params => {
	params = TOKEN_DATA + Base64.encode(JSON.stringify(params))
	return axios.post(BASE_URL+'/spbd/order/add?=' + new Date().getTime() + '&data=' + params)
		.then(res => res.data);
};
//浦发支付--订单查询
export const reqPFSearch = params => {
	params = TOKEN_DATA + Base64.encode(JSON.stringify(params))
	return axios.post(BASE_URL+'/spbd/order/search?=' + new Date().getTime() + '&data=' + params)
		.then(res => res.data);
};
//浦发支付--订单清算
export const reqPFClear = params => {
	params = TOKEN_DATA + Base64.encode(JSON.stringify(params))
	return axios.post(BASE_URL+'/spbd/order/clear?=' + new Date().getTime() + '&data=' + params)
		.then(res => res.data);
};
//修改订单状态
export const reqPFStatus = params => {
	params = TOKEN_DATA + Base64.encode(JSON.stringify(params))
	return axios.post(BASE_URL+'/spbd/order/status?=' + new Date().getTime() + '&data=' + params)
		.then(res => res.data);
};

//浦发支付--订单更新
export const reqPFUpdate = params => {
	params = TOKEN_DATA + Base64.encode(JSON.stringify(params))
	return axios.post(BASE_URL+'/pay/order/micropay/update?=' + new Date().getTime() + '&data=' + params)
		.then(res => res.data);
};
//缴费订单---查询用户订单
export const reqOrderList= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/pay/order/list?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费订单---查询用户订单详情明细
export const reqOrderDetail= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/pay/order/detail?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//缴费订单---删除订单
export const reqOrderDelete= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/pay/order/delete?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
export const reqSearchparam= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/spbd/order/searchparam?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//供热报修---报修电话查询
export const reqRepairphone= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/repair/station?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//供热报修---报修类型
export const reqRepairType= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/repair/type?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//供热报修---上传图片
export const reqUploaderImg= params => {
  return axios.post(BASE_URL+'/user/info/headImg?='+new Date().getTime(), params)
    .then(res => res.data);
};
//供热报修---提交供热报修
export const reqRepairOrderAdd= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  params=params.replace(/\+/g,'|')
  params=params.replace(/-/g,'_')
  return axios.post(BASE_URL+'/repair/order/add?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//供热报修---报修订单
export const reqRepairOrderList= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/repair/user/order?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};

//地址管理---地址列表
export const reqAddressList= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/user/room/list?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//地址管理---地址新增
export const reqAddressAdd= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  params=params.replace(/\+/g,'|')
  params=params.replace(/-/g,'_')
  return axios.post(BASE_URL+'/user/room/add?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//地址管理---地址编辑
export const reqAddressEdit= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  params=params.replace(/\+/g,'|')
  params=params.replace(/-/g,'_')
  return axios.post(BASE_URL+'/user/room/edit?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//地址管理---地址删除
export const reqAddressDel= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/user/room/del?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//地址管理---获取标签
export const reqRoomTaglist= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/user/room/taglist?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//供热状态变更---获取房屋信息
export const reqRoomInfo= params => {
  //params = JSON.stringify(params)
  return axios({
  method: 'post',url:'/app/process/getRoomInfo',data:params,headers:{'Content-Type':'application/json;charset=UTF-8'}})
    .then(res => res.data);
};
//供热状态变更---提交
export const saveProcessOrder= params => {
  //params = JSON.stringify(params)
  return axios({
  method: 'post',url:'/app/process/saveProcessOrder',data:params,headers:{'Content-Type':'application/json;charset=UTF-8'}})
    .then(res => res.data);
};
//供热状态变更---获取列表
export const reqProcessOrderList= params => {
  //params = JSON.stringify(params)
  return axios({
  method: 'post',url:'/app/process/getProcessOrderList',data:params,headers:{'Content-Type':'application/json;charset=UTF-8'}})
    .then(res => res.data);
};
//供热状态变更---获取详情
export const reqProcessOrderInfo= params => {
  //params = JSON.stringify(params)
  return axios({
  method: 'post',url:'/app/process/getProcessOrderInfo',data:params,headers:{'Content-Type':'application/json;charset=UTF-8'}})
    .then(res => res.data);
};
//供热状态变更---获取详情
export const reqProcessCode= params => {
  //params = JSON.stringify(params)
  return axios({
  method: 'post',url:'/app/process/code',data:params,headers:{'Content-Type':'application/json;charset=UTF-8'}})
    .then(res => res.data);
};

//抽奖---活动信息
export const reqActivity= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/turntable/activity?='+new Date().getTime())
    .then(res => res.data);
};
//抽奖---奖品列表
export const reqTurndraw= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/turntable/turndraw?='+new Date().getTime())
    .then(res => res.data);
};
//抽奖---中奖记录
export const reqTurnrecord= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/turntable/turnrecord?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//抽奖---抽奖
export const reqWard= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/turntable/award?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};
//抽奖---校验是否参与过抽奖
export const reqCheck= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/turntable/check?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};

//评价---评价列表
export const reqEvaluateList= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/evaluate/list?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};

//评价---添加评价
export const reqEvaluateAdd= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  params=params.replace(/\+/g,'|')
  params=params.replace(/-/g,'_')
  return axios.post(BASE_URL+'/evaluate/add?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};

//发票---发票列表
export const reqInvoiceList= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/invoice/list?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};

//发票---发票列表
export const reqInvoiceApply= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  params=params.replace(/\+/g,'|')
  params=params.replace(/-/g,'_')
  return axios.post(BASE_URL+'/invoice/apply?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};

//发票---发票列表
export const uploadInvoice= params => {
	return axios.post('/common/upload',params,{headers:{'Content-Type':'multipart/form-data'}})
	.then(res => res.data);
};

export const getPdfBlob= params => {
	return axios.post('/common/download-invoice?invoiceName='+params,{})
	.then(res => res.data);
};
//停热
export const stopHot= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/onsite/stopHot?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};

//恢复
export const recoverHot= params => {
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/onsite/recoverHot?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};

//查询是否绑定阀门
export const valveRel= params => {
	
	console.log(params)
  params = TOKEN_DATA+Base64.encode(JSON.stringify(params))
  return axios.post(BASE_URL+'/pay/room/valve-rel?='+new Date().getTime(), 'data='+params)
    .then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/api/index.js